exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SidebarHeader__logo___2S7yw {\n  margin: 20px 0 10px 15px !important;\n  padding: 3px; }\n  .SidebarHeader__logo___2S7yw img {\n    width: 110px; }\n\n.SidebarHeader__header___YVZ2E {\n  width: 200px;\n  max-width: 200px;\n  background-color: #242424;\n  color: #aaa; }\n", ""]);

// exports
exports.locals = {
	"logo": "SidebarHeader__logo___2S7yw",
	"header": "SidebarHeader__header___YVZ2E"
};